<template>
	<section>
		<p class="f-20 f-m-14 margin-0"><strong>Pengaturan</strong></p>
		<p class="f-14 f-m-12 c-grey margin-0"></p>
		<hr>
		<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
			<p class="f-14 f-m-12 margin-0"><strong>Printer</strong></p>
			<div class="row">
				<div class="col">
					<div class="form-check mb-0">
						<input type="checkbox" v-model="model.bluetooth_print" class="form-check-input" />
						<label class="form-check-label" for="">Bluetooth Print</label>
					</div>
				</div>  
			</div>  
			<hr>
			
			<button type="submit" class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
		</ValidationObserver>
	</section>
</template>

<script>
export default {
	name: 'Setting',
	data(){
		return{
			model: {
				bluetooth_print: (localStorage.getItem('bluetooth_print') === 'true') ? true : false
			}
		}
	},
	methods:{
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				localStorage.setItem('bluetooth_print', _.model.bluetooth_print)
			}
		}
	}
}
</script>